import { render, staticRenderFns } from "./orderSnapshot.vue?vue&type=template&id=f1521650&scoped=true&"
import script from "./orderSnapshot.vue?vue&type=script&lang=ts&"
export * from "./orderSnapshot.vue?vue&type=script&lang=ts&"
import style0 from "./orderSnapshot.less?vue&type=style&index=0&id=f1521650&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1521650",
  null
  
)

export default component.exports